import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import fetch from "../../../utils/fetch";
import { getAuditChanges } from "../CroActions";
import Button from "../../../components/form/Button";
import { styles } from "../index";
import AuditHistoryDetailPanel from "./audit/AuditHistoryDetailPanel";
import AuditHistoryNoteDialog from "./audit/AuditHistoryNoteDialog";
import { resolveStatementVersionPair } from "./audit/statementDiffSummary";
import {
  ownerHref as resolveOwnerHref,
  ownerHistoryHref as resolveOwnerHistoryHref,
} from "./audit/ownerRoutes";

/**
 * Reusable audit-history view: a history grid plus a per-field detail
 * panel. Clicking a grid row fetches the revision's field-level diffs
 * and renders them in the detail pop-up.
 
 */
class AuditHistoryView extends Component {
  state = {
    selected: null,
    detail: null,
    loading: false,
    error: null,
    noteOpen: false,
    reloadKey: 0,
  };

  openStatementDiff = (row) => {
    const { auth, dispatch, officialId } = this.props;
    this.setState({ loading: true, error: null });
    resolveStatementVersionPair({
      row,
      auth,
      fallbackOfficialId: officialId,
      fetchFn: fetch,
      dispatch,
    })
      .then(({ targetOfficialId, versions, idx }) => {
        this.setState({ loading: false });
        dispatch(
          push({
            pathname: `${auth.startUrl}/funkcionari/${targetOfficialId}/oznameni/verze`,
            state: {
              statement: versions[idx],
              prevVersion: versions[idx + 1],
              versionValidTo: versions[idx - 1] && versions[idx - 1].versionDateTime,
            },
          }),
        );
      })
      .catch((err) =>
        this.setState({
          loading: false,
          error: err && err.message ? err.message : String(err),
        }),
      );
  };

  closeDetail = () => {
    this.setState({ selected: null, detail: null, error: null, loading: false });
  };

  handleRowClick = (row) => {
    if (!row) return;
    // STATEMENT rows: open detail with just the navigation button — no inline diff.
    if (row.detailType === "STATEMENT") {
      this.setState({ selected: row, detail: null, loading: false, error: null });
      return;
    }
    if (!row.auditRowId) {
      this.setState({
        error: "Řádek bez auditRowId — nelze zobrazit detail.",
        detail: null,
        selected: row,
      });
      return;
    }
    const { auth } = this.props;
    this.setState({ selected: row, loading: true, error: null, detail: null });
    getAuditChanges(auth.startUrl, row.auditRowId, this.props.dispatch)
      .then((data) => this.setState({ detail: data || [], loading: false }))
      .catch((err) =>
        this.setState({
          loading: false,
          error: "Chyba při načítání detailu: " + (err && err.message ? err.message : err),
        }),
      );
  };

  render() {
    const { auth, grid: Grid, gridName, url, noteTarget, showOwner, showEntity, showNote, allowedEntityTypes, allowedActions, dispatch } = this.props;
    const { selected, detail, loading, error, noteOpen, reloadKey } = this.state;
    const ownerHref = selected
      ? resolveOwnerHref(selected.ownerType, selected.ownerId, auth && auth.startUrl)
      : null;
    const ownerHistoryHref = selected
      ? resolveOwnerHistoryHref(selected.ownerType, selected.ownerId, auth && auth.startUrl)
      : null;
    return (
      <div>
        {noteTarget && (
          <div style={{ marginBottom: 12 }}>
            <Button
              type="button"
              style={styles.buttons}
              label="Přidat poznámku"
              onClick={() => this.setState({ noteOpen: true })}
            />
          </div>
        )}
        <AuditHistoryNoteDialog
          open={noteOpen}
          target={noteTarget}
          auth={auth}
          dispatch={dispatch}
          onClose={() => this.setState({ noteOpen: false })}
          onSaved={() => this.setState((s) => ({ noteOpen: false, reloadKey: s.reloadKey + 1 }))}
        />
        <Grid
          key={reloadKey}
          gridName={gridName}
          url={url}
          showOwner={showOwner}
          showEntity={showEntity}
          showNote={showNote}
          allowedEntityTypes={allowedEntityTypes}
          allowedActions={allowedActions}
          onRowClick={this.handleRowClick}
          auth={auth}
          dispatch={dispatch}
        />
        <AuditHistoryDetailPanel
          selected={selected}
          detail={detail}
          loading={loading}
          error={error}
          ownerHref={ownerHref}
          ownerHistoryHref={ownerHistoryHref}
          onClose={this.closeDetail}
          onOwnerNavigate={(href) => dispatch(push(href))}
          onOpenStatementDiff={this.openStatementDiff}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({ dispatch });

export default connect(null, mapDispatchToProps)(AuditHistoryView);
